export const pagePath = (module, page) => `/${module.path}/${page.path}`;
//# sourceMappingURL=module.js.map